module.exports = __webpack_public_path__ + "img/bg-login-page-dark.686a24af.svg";